var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarInterviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_282_8797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2335 6.27436C12.7815 6.27436 14.0364 5.019 14.0364 3.47043C14.0364 1.92186 12.7815 0.666504 11.2335 0.666504C9.68556 0.666504 8.43066 1.92186 8.43066 3.47043C8.43066 5.019 9.68556 6.27436 11.2335 6.27436Z",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7049 15.3334C11.6945 15.3334 10.1176 15.3334 10.1176 15.3334M10.1176 15.3334H2.59201C2.19903 15.3334 1.85573 15.0676 1.75712 14.6871L0.695037 10.589C0.553465 10.0427 0.965731 9.50977 1.52992 9.50977H7.74872C8.13069 9.50977 8.46721 9.7611 8.57571 10.1274L10.1176 15.3334Z",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14062 9.99994V9.29394C7.14062 8.10281 8.10598 7.13721 9.29682 7.13721H13.1774C14.3682 7.13721 15.3336 8.10281 15.3336 9.29394V11.4511C15.3336 12.6422 14.3682 13.6078 13.1774 13.6078H11.8324H9.998",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6643 9.33301C12.6643 10.2859 12.405 11.2349 11.4523 11.2349H9.66504",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_282_8797"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarInterviewIcon);
export default __webpack_public_path__ + "static/media/sidebar-interview-icon.c4f50a3972369f03b26e4179db05d30c.svg";
export { ForwardRef as ReactComponent };